import React from "react";
import { motion } from "framer-motion";

const BRANDS = [
  { name: "HP", logo: "/images/brands/hp.svg", className: "h-12" },
  { name: "Canon", logo: "/images/brands/canon.svg", className: "h-8" },
  { name: "Epson", logo: "/images/brands/epson.svg", className: "h-8" },
  { name: "Ricoh", logo: "/images/brands/ricoh.svg", className: "h-8" },
  { name: "Brother", logo: "/images/brands/brother.svg", className: "h-8" },
  { name: "Xerox", logo: "/images/brands/xerox.svg", className: "h-9" },
];

export default function BrandStrip() {
  return (
    <section className="relative border-y border-border bg-background py-14 lg:py-16" data-testid="printer-brands">
      <div className="w-full px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground font-semibold">
                Consumíveis de impressão
              </div>
              <h2 className="mt-2 font-display text-2xl sm:text-3xl font-semibold text-foreground tracking-tight">
                Tinteiros e toners para as principais marcas
              </h2>
            </div>
            <p className="text-sm text-muted-foreground max-w-md md:text-right leading-relaxed">
              Ajudamos a encontrar a referência certa para cada equipamento.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {BRANDS.map((brand) => (
              <div
                key={brand.name}
                className="group h-24 rounded-xl border border-border bg-card px-6 flex items-center justify-center shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:border-foreground/20"
                data-testid={`brand-${brand.name.toLowerCase()}`}
              >
                <img
                  src={brand.logo}
                  alt={`${brand.name} — consumíveis disponíveis`}
                  className={`${brand.className} max-w-full w-auto object-contain transition-transform duration-300 group-hover:scale-105`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <p className="mt-4 text-[11px] text-muted-foreground/70 leading-relaxed">
            As marcas apresentadas pertencem aos respetivos proprietários e são utilizadas apenas para identificar a compatibilidade dos consumíveis.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
